module.exports = __webpack_public_path__ + "media/src/images/logos/partners/vnies-9e51c3699366dcdbc5943cf192e537f5.jpg";